/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ClassNames from 'classnames';

import {PasswordChange} from '../../../actions/auth/actions-auth';

import DivLoader from '../../../components/DivLoader';
import Translate from '../../../components/Translate';

class ChangePasswordTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formOldPassword: '',
      formNewPassword: '',
      formNewPassword2: ''
    }
  }

  componentDidMount() {
    document.getElementById('old_password') && document.getElementById('old_password').focus();

    document.getElementById('dummy_submit') && document.getElementById('dummy_submit').addEventListener('focus', function (e) {

      document.getElementById('old_password') && document.getElementById('old_password').focus();
    }, true);

  }

  componentWillReceiveProps(newProps) {

    if (newProps.isError) {
      document.getElementById('old_password') && document.getElementById('old_password').focus();
    }
  }

  _onOldPasswordChange(event) {

    this.setState({formOldPassword: event.target.value});
  }
  
  _onNewPasswordChange(event) {

    this.setState({formNewPassword: event.target.value});
  }

  _onNewPassword2Change(event) {

    this.setState({formNewPassword2: event.target.value});
  }

  _onSubmit(event) {
    event.preventDefault && event.preventDefault();

    this.props.PasswordChange(this.state.formOldPassword, this.state.formNewPassword, this.state.formNewPassword2);
  }

  render() {

    if (this.props.isSuccess && !this.props.inProgress) {

      return (<div className="settings-col">
        <p className="mt">
          <Translate content="settings.tabs.change_password.success" />
        </p>
      </div>);
    }

    const oldPasswordClasses = ClassNames({
      'error-field': this.props.isError && (this.props.errorMsg === 'invalid credentials' || this.props.errorMsg === 'password field empty'),
      'auth-field': true
    });

    const newPasswordClasses = ClassNames({
      'error-field': this.props.isError && this.props.errorMsg === 'password too short',
      'auth-field': true
    });


    const newPassword2Classes = ClassNames({
      'error-field': this.props.isError && this.props.errorMsg === 'passwords mismatch',
      'auth-field': true
    });

    return (
      <div className="relative">
        <DivLoader loading={this.props.inProgress} />
        <form id="regForm" className="js-form" role="form" onSubmit={this._onSubmit.bind(this)}>
          <div className="settings-col" style={{verticalAlign: 'top'}}>
            <label htmlFor="old_password_settings"> <Translate content="settings.tabs.change_password.old_password" /> </label>
            <input id="old_password" name="username" type="password" className={oldPasswordClasses} tabIndex="1"
                   value={this.state.formOldPassword} onChange={this._onOldPasswordChange.bind(this)} />
            <label htmlFor="user_password"> <Translate content="settings.tabs.change_password.new_password" /> </label>
            <input id="user_password" name="password" type="password" className={newPasswordClasses} tabIndex="2"
                   value={this.state.formNewPassword} onChange={this._onNewPasswordChange.bind(this)} />
            <label htmlFor="user_password2"> <Translate content="settings.tabs.change_password.new_password2" /> </label>
            <input id="user_password2" name="password2" type="password" className={newPassword2Classes} tabIndex="3"
                   value={this.state.formNewPassword2} onChange={this._onNewPassword2Change.bind(this)} />
            <a className="btn-dark authorization" href="javascript:void(0)" onClick={this._onSubmit.bind(this)}>
              <Translate content="settings.tabs.change_password.save" /> </a>
          </div>
          <input id="dummy_submit" type="text" style={{height: 0, width: 0, opacity: 0, display: 'block', float: 'left'}} tabIndex="4" />
          <button type="submit" style={{height: 0, opacity: 0, visibility: 'hidden'}} tabIndex="5">Submit</button>
        </form>
        {this.props.isError && <div className="reg-error-message" style={{position: 'absolute', top: '15px', right: '50px'}}>
          <em> <Translate content={`error.${this.props.errorMsg}`} /> </em>
        </div>}
      </div>
    );
  }
}

ChangePasswordTab.propTypes = {
  inProgress: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string
};

const mapStateToProps = ({auth: {change_password: {inProgress, isSuccess, isError, errorMsg}}}) => {

  return {inProgress, isSuccess, isError, errorMsg};
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({PasswordChange}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/change-password.js